import { useEffect, useState } from 'react';
import ProviderStore from 'store/Provider';
import { Provider } from 'types/provider';
import useGetSettingData from './useGetSettingData';
import { EnumFields, SettingEnum } from 'types/enumerationData';
import { getUserId } from 'utils/localstore';
import { providerFetch } from 'api/provider';
import useLoadBasicData from 'hooks/useLoadBasicData';
import dayjs from 'dayjs';

const useGetOffForProlisting = (isOps?: boolean): [number | undefined, boolean] => {
    const [off, setOff] = useState<number | undefined>(isOps ? 150 : undefined);
    const [loading, setLoading] = useState(false);
    const [getProvider] = ProviderStore.useStore();
    const [prolistingConfig] = useGetSettingData(EnumFields.PRO_LISTING_CONFIG);
    const [loadBasicData] = useLoadBasicData();

    useEffect(() => {
        loadBasicData();
    }, [loadBasicData]);

    const fetchData = async () => {
        if (loading) return;

        try {
            setLoading(true);
            const res = await providerFetch(getUserId()!);
            if (!res.error) {
                const provider: Provider = res.data?.data;
                if (provider.createTime && prolistingConfig && (prolistingConfig?.[0] as SettingEnum).content) {
                    if (dayjs(provider.createTime).isBefore(dayjs((prolistingConfig?.[0] as SettingEnum).content))) {
                        setOff(300);
                    } else {
                        setOff(150);
                    }
                }
            } else {
                setOff(150);
            }
        } catch (e) {
            setOff(150);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (prolistingConfig && !isOps) {
            fetchData();
        }
    }, [prolistingConfig]);

    return [
        off,
        loading,
    ];
};

export default useGetOffForProlisting;
